"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _UINavList = _interopRequireDefault(require("./UINavList"));

var _HR = _interopRequireDefault(require("../elements/HR"));

var _H = _interopRequireDefault(require("../elements/headings/H7"));

var UINestedNav = _react.default.createClass({
  displayName: "UINestedNav",
  propTypes: (0, _extends2.default)({}, _UINavList.default.propTypes, {
    divider: _propTypes.default.bool,
    headingText: _propTypes.default.node
  }),
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, _UINavList.default.defaultProps, {
      divider: false,
      headingText: ''
    });
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        divider = _this$props.divider,
        headingText = _this$props.headingText,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "divider", "headingText"]);
    return _react.default.createElement(_UINavList.default, (0, _extends2.default)({}, rest, {
      className: className,
      _rootComponent: UINestedNav
    }), divider ? _react.default.createElement(_HR.default, null) : null, headingText ? _react.default.createElement(_H.default, null, headingText) : null, children);
  }
});

var _default = UINestedNav;
exports.default = _default;
module.exports = exports.default;